import React from 'react'
import { ImSpinner2 } from 'react-icons/im';
import './waiting.styling.scss';

function Waiting() {
  return (
    <div id='waiting-animation'>
      <ImSpinner2 />
    </div>
  )
}

export default Waiting